import React, { useState } from 'react';
import BiomePieChart from './BiomePieChart';

const BiomeTree = ({ multipleSamplesMetaData, possibleColorDict }) => {
    const splitBiome = (biome) => {
        return biome
            .replace(/root/g, '')
            .split(':')
            .map(s => s.trim())
            .filter(s => s)
            .join(' ')
            .split(' ')
            .filter(s => s);
    };

    const createTree = (data) => {
        const root = { name: 'root', children: {}, count: 0, totalCount: 0 };

        data.forEach(sample => {
            const biomePath = splitBiome(sample.meta_data.source_biome);
            let current = root;

            biomePath.forEach(level => {
                if (!current.children[level]) {
                    current.children[level] = {
                        name: level,
                        children: {},
                        count: 0,
                        totalCount: 0
                    };
                }
                current.children[level].totalCount++;
                current = current.children[level];
            });
            current.count++;
        });

        return root;
    };

    const TreeNode = ({ node, name, level = 0, path = [] }) => {
        const [isOpen, setIsOpen] = useState(true);
        const hasChildren = Object.keys(node.children).length > 0;

        const currentPath = [...path, name];
        const colorKey = ['root', ...currentPath].join(':');
        // const color = possibleColorDict[colorKey];
        const color = `rgb(0, 0, 0)`;

        const colorStyle = color ?
            `rgb(${color[0]}, ${color[1]}, ${color[2]})` :
            'black';

        return (
            <div>
                <div style={{ paddingLeft: `${level * 20}px`, marginBottom: '4px' }}>
                    {hasChildren && (
                        <span
                            onClick={() => setIsOpen(!isOpen)}
                            style={{ cursor: 'pointer', marginRight: '8px' }}
                        >
                            {isOpen ? '▼' : '▶'}
                        </span>
                    )}
                    <span style={{ color: colorStyle }}>
                        {name}
                        {node.count > 0 && ` (${node.count} samples)`}
                        {node.totalCount > node.count && node.totalCount > 0 &&
                            ` (${node.totalCount} cumulative samples)`}
                    </span>
                </div>

                {isOpen && hasChildren && (
                    <div>
                        {Object.entries(node.children).map(([childName, childNode]) => (
                            <TreeNode
                                key={childName}
                                node={childNode}
                                name={childName}
                                level={level + 1}
                                path={currentPath}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const tree = createTree(multipleSamplesMetaData);


    return (
        <div style={{ fontFamily: 'monospace' }}>
            <p style={{ marginBottom: '12px' }}>Biome Distribution:</p>

            <BiomePieChart
                multipleSamplesMetaData={multipleSamplesMetaData}
                possibleColorDict={possibleColorDict}
            />
            {Object.entries(tree.children).map(([name, node]) => (
                <TreeNode
                    key={name}
                    node={node}
                    name={name}
                    level={0}
                />
            ))}
        </div>
    );
};

export default BiomeTree;